var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77885 1.67122C5.95226 1.84469 6.04967 2.07993 6.04967 2.32521C6.04967 2.57048 5.95226 2.80572 5.77885 2.97919L3.6578 5.10024H8.82492C10.5422 5.10024 12.1892 5.78244 13.4034 6.99675C14.6178 8.21103 15.3 9.85801 15.3 11.5753V13.4253C15.3 13.6706 15.2025 13.906 15.0291 14.0794C14.8556 14.2529 14.6203 14.3503 14.375 14.3503C14.1297 14.3503 13.8944 14.2529 13.7209 14.0794C13.5474 13.906 13.45 13.6706 13.45 13.4253V11.5753C13.45 10.3486 12.9627 9.1723 12.0953 8.30492C11.2279 7.43754 10.0516 6.95027 8.82492 6.95027H3.6578L5.77885 9.07129C5.86719 9.15667 5.93766 9.2587 5.98614 9.37155C6.03462 9.4844 6.06013 9.60585 6.06121 9.7286C6.06227 9.85145 6.03887 9.97327 5.99236 10.087C5.94585 10.2006 5.87716 10.3039 5.79031 10.3907C5.70346 10.4776 5.60018 10.5463 5.4865 10.5928C5.37281 10.6393 5.25101 10.6627 5.12819 10.6617C5.00537 10.6606 4.88399 10.635 4.77113 10.5866C4.65828 10.5381 4.5562 10.4676 4.47088 10.3793L0.770834 6.67924C0.597422 6.50577 0.5 6.27053 0.5 6.02525C0.5 5.77998 0.597422 5.54474 0.770834 5.37127L4.47088 1.67122C4.64434 1.49781 4.87958 1.40039 5.12486 1.40039C5.37014 1.40039 5.60538 1.49781 5.77885 1.67122Z",
    fill: "#36A4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.ebfe51e54124745f67245df851a898b3.svg";
export { ForwardRef as ReactComponent };